import { Banknote, Briefcase, FolderOpen, GraduationCap } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../logo/lo.png';
import placementPortfolio from '../assets/placement protfolio/Placement Portfolio.pdf';
import { InstagramIcon, LinkedInIcon, WhatsAppIcon, YouTubeIcon } from './SocialIcons';

const Footer = () => {
  const columns = [
    {
      title: 'Education',
      links: [
        { name: 'All Courses', path: '/courses' },
        { name: 'GEN AI - AIML', path: '/courses#aiml' },
        { name: 'GEN AI - Full Stack Analytics', path: '/courses#full-stack-analytics' },
        { name: '50% Pay After Placement', path: '/enroll' },
        { name: 'Success Stories', path: '/success-stories' },
      ],
    },
    {
      title: 'HR Consulting',
      links: [
        { name: 'Fresher Hiring', path: '/hr-consulting#fresher' },
        { name: 'Technical Assessments', path: '/hr-consulting#assessment' },
        { name: 'Talent Acquisition', path: '/hr-consulting#talent' },
        { name: 'HR Process Consulting', path: '/hr-consulting#process' },
        { name: 'Careers at Vista Tech', path: '/careers' },
      ],
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Blog', path: '/blog' },
        { name: 'Contact', path: '/contact' },
        { name: 'Terms & Conditions', path: '/Terms-and-Conditions' },
      ],
      extra: [
        { name: 'Placement Portfolio', href: placementPortfolio },
      ],
    },
  ];

  return (
    <footer style={{ background: 'linear-gradient(135deg, #0d0b14, #1a1530)', color: 'white', fontFamily: 'Poppins, sans-serif' }}>

      {/* Main Footer */}
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '80px 1.5rem 60px' }}>
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr 1fr', gap: '48px', marginBottom: '60px' }}>

          {/* Brand column */}
          <div>
            <img src={logo} alt="Vista Tech" style={{ height: '60px', width: 'auto', objectFit: 'contain', marginBottom: '20px', filter: 'brightness(1.1)' }} />
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', lineHeight: 1.7, marginBottom: '24px', maxWidth: '280px' }}>
              India's leading IT training institute and HR consulting firm. We build careers and teams.
            </p>

            {/* Key highlight */}
            <div style={{ background: 'rgba(240,180,41,0.12)', border: '1px solid rgba(240,180,41,0.25)', borderRadius: '12px', padding: '16px', marginBottom: '24px' }}>
              <div style={{ color: '#F0B429', fontWeight: '700', fontSize: '0.875rem', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Banknote size={15} /> 50% Pay After Placement
              </div>
              <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.78rem' }}>Pay half upfront. Rest after you're hired.</div>
            </div>

            {/* Social links */}
            <div style={{ display: 'flex', gap: '10px' }}>
              {[
                { icon: <LinkedInIcon size={17} />, label: 'LinkedIn', href: '#' },
                { icon: <InstagramIcon size={17} />, label: 'Instagram', href: '#' },
                { icon: <YouTubeIcon size={17} />, label: 'YouTube', href: '#' },
                { icon: <WhatsAppIcon size={17} />, label: 'WhatsApp', href: '#' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  title={s.label}
                  style={{
                    width: '36px', height: '36px', borderRadius: '8px',
                    background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'rgba(255,255,255,0.7)', textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(240,180,41,0.2)'; e.currentTarget.style.color = '#F0B429'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {columns.map((col) => {
            const colIcon = col.title === 'Education' ? <GraduationCap size={14} />
              : col.title === 'HR Consulting' ? <Briefcase size={14} />
              : null;
            return (
            <div key={col.title}>
              <h4 style={{ fontSize: '0.8rem', fontWeight: '700', color: 'rgba(255,255,255,0.9)', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'flex', alignItems: 'center', gap: '6px' }}>
                {colIcon && <span style={{ opacity: 0.7 }}>{colIcon}</span>}
                {col.title}
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {col.links.map((l) => (
                  <li key={l.name}>
                    <Link
                      to={l.path}
                      style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.85rem', textDecoration: 'none', transition: 'color 0.2s' }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = '#F0B429'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.55)'; }}
                    >
                      {l.name}
                    </Link>
                  </li>
                ))}
                {col.extra?.map((e) => (
                  <li key={e.name}>
                    <a
                      href={e.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#F0B429', fontSize: '0.85rem', textDecoration: 'none', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                    >
                      <FolderOpen size={14} />{e.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          );
          })}
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem' }}>
            © {new Date().getFullYear()} Vista Tech. All rights reserved. | IT Training · HR Consulting
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            {[
              { name: 'Privacy Policy', path: '/Terms-and-Conditions' },
              { name: 'Terms of Service', path: '/Terms-and-Conditions' },
              { name: 'Sitemap', path: '/sitemap.xml' },
            ].map((l) => (
              <Link
                key={l.name}
                to={l.path}
                style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.78rem', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.4)'; }}
              >
                {l.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
